export default "__VITE_ASSET__D0knF$mf__"